import { useTranslation } from "next-i18next";

import { DialogProductContainerInfo } from "@/components/DialogProductContainerInfo";
import { DispenserDialogContent } from "@/components/DispenserDialogContent";
import useDialog, { DialogTheme } from "@/hooks/useDialog";
import { useInventory } from "@/hooks/useInventory";

const useProductDetailsPage = () => {
  const { showDialog } = useDialog();
  const { t } = useTranslation();
  const { data: inventoryData } = useInventory();

  const getInStock = (skuCode) => {
    if (!inventoryData) return true; // to show active Add Cart button for the first seconds after page load
    const quantity =
      inventoryData.productQuantitiesBySku?.[skuCode]?.available_quantity;

    return quantity > 0;
  };

  const handleRelativePackagingInfoClick = (
    relativePackaging,
    size_original,
    size
  ) => {
    const relativePackaging1DecimalPlace =
      Math.floor(relativePackaging * 10) / 10;

    showDialog(
      <DialogProductContainerInfo
        comparisonNumber={relativePackaging1DecimalPlace}
        comparisonSize={size_original}
        containerSize={size}
      />,
      t("dialog_product_container_info_title"),
      "regular",
      DialogTheme.LIGHT
    );
  };

  const handleDispenserReadMoreClick = () => {
    const content = <DispenserDialogContent />;
    showDialog(content, t("how_it_works_step_2_info_header"));
  };

  return {
    handleRelativePackagingInfoClick,
    handleDispenserReadMoreClick,
    getInStock,
  };
};

export default useProductDetailsPage;
